import { TableColumn } from "components/table/Table";
import TableTruncate from "components/table/renderComponents/TableTruncate";
import TableImage from "components/table/renderComponents/TableImage";
import { getDataBasedOnLang } from "utils/getDataBasedOnLang";

export interface Data {
  _id: string;
  title: any;
  description: any;
  url: string;
  images: string[];
  listOrderNumber: number;
  categoryIds: string[];
  createdAt: string;
}

export const columns: TableColumn<Data>[] = [
  { key: "_id", label: "id", sortable: true, render: (item) => <TableTruncate text={item._id} withCopy /> },
  { key: "images", label: "images", sortable: true, render: (item) => <TableImage image={item.images?.[0]} /> },
  { key: "title", label: "title", sortable: true, render: (item) => getDataBasedOnLang(item.title) },
  { key: "url", label: "url", sortable: true },
  { key: "listOrderNumber", label: "listOrderNumber", sortable: true },
  { key: "createdAt", label: "createdAt", sortable: true },
];
